/**
 * Sales categories for Take A Lot programme
 */
export const SALES_CATEGORIES = [
  'Electronics',
  'Clothing & Apparel',
  'Home & Garden',
  'Toys & Games',
  'Sports & Outdoors',
  'Beauty & Personal Care',
  'Books & Stationery',
  'Food & Beverages',
  'Health & Wellness',
  'Automotive',
  'Furniture',
  'Other'
];

/**
 * Programme metadata
 */
export const TAKE_A_LOT_PROGRAM = {
  name: 'Take A Lot',
  code: 'TAKE_A_LOT',
  description: 'Sales recording for Take A Lot training programme'
};
